import React from "react"

import { Skeleton } from "@material-ui/lab"
import { Grid, makeStyles } from "@material-ui/core"
import { SkeletonProps } from "@/protocols/skeleton"

import {
	Portlet
} from "@/components"

const useStyles = makeStyles({
	container: {
		height: 70
	}
})

const DeviceAndSessionsSkeleton: React.FC<SkeletonProps> = ({ rows = 1 }) => {
	const classes = useStyles()

	return (
		<Grid container direction="column" spacing={2}>
			{Array.from({ length: rows }).map((_, index) => (
				<Grid item key={index}>
					<Portlet elevation={1}>
						<Grid
							container
							alignItems="center"
							className={classes.container}
							spacing={2}
						>
							<Grid item xs={6}>
								<Grid container alignItems="center" spacing={2}>
									<Grid item>
										<Skeleton variant="rect" width={40} height={40} style={{ borderRadius: 5 }}/>
									</Grid>
									<Grid item>
										<Skeleton variant="text" width={240} height={30} style={{ borderRadius: 5 }}/>
										<Skeleton variant="text" width={150} height={30} style={{ borderRadius: 5 }}/>
									</Grid>
								</Grid>
							</Grid>

							<Grid item xs={6}>
								<Grid container alignItems="center" justifyContent="space-between" spacing={2}>
									<Grid item>
										<Skeleton variant="text" width={240} height={30} style={{ borderRadius: 5 }}/>
									</Grid>
									<Grid item>
										<Skeleton variant="rect" width={60} height={60} style={{ borderRadius: 10 }}/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Portlet>
				</Grid>
			))}
		</Grid>
	)
}

export default DeviceAndSessionsSkeleton
